// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bf_s"};